module.exports = __webpack_public_path__ + "img/Group 2@2x.8bdf8c47.png";